var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('app-loader'),_c('notifications',{attrs:{"position":"bottom left","width":"100%","classes":"app-notification","duration":2000}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }